// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"Z1-z","dimensionLabel":"_1-z","styleChooserControlWrapper":"a2-z","styleChooserControl":"b2-z","disabled":"c2-z","giftCard":"d2-z","styleChooserText":"e2-z"};